module.exports = __webpack_public_path__ + "static/media/sc5.8d01dfe8.jpg";